import { render, staticRenderFns } from "./ProposalRequestDetermination.vue?vue&type=template&id=2cb87944"
import script from "./ProposalRequestDetermination.vue?vue&type=script&lang=js"
export * from "./ProposalRequestDetermination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb87944')) {
      api.createRecord('2cb87944', component.options)
    } else {
      api.reload('2cb87944', component.options)
    }
    module.hot.accept("./ProposalRequestDetermination.vue?vue&type=template&id=2cb87944", function () {
      api.rerender('2cb87944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/proposalProcess/components/ProposalRequestDetermination.vue"
export default component.exports